import { API_URL } from '$lib/conf'
import { writable } from 'svelte/store'

let defaultValue = {
    posicion_ingresos: [
        { value: '1', label: 'Contribuyente Local' },
        { value: '2', label: 'Convenio Multilateral' },
        { value: '3', label: 'Régimen Simplificado' },
        { value: '4', label: 'Exento' },
        { value: '5', label: 'Agente de Retención' },
        { value: '6', label: 'No responsable' },
        { value: '7', label: 'Sujeto no pasible de retención' },
        { value: '8', label: 'Sujeto no contribuyente' },
    ],
    condicion_iva: [
        { value: '1', label: 'Responsable Inscripto' },
        { value: '2', label: 'Monotributo' },
        { value: '3', label: 'Sujeto no categorizado / RNI' },
        { value: '4', label: 'Exento' },
        { value: '5', label: 'Sujeto comprendido en la R.G. 17/97 - 2226/07' },
        { value: '6', label: 'Agente de retencion (R.G. 18/97 - 2854/10)' },
        { value: '7', label: 'No Responsable' },
    ],
    empleador: [
        { value: '1', label: 'EMPLEADOR' },
        {
            value: '2',
            label: 'EMPRESA CONTRATISTA Y/O SUBCONTRATISTA DE LA INDUSTRIA DE LA CONSTRUCCIÓN',
        },
        {
            value: '3',
            label: 'PRESTADOR DE SERVICIOS DE LIMPIEZA DE INMUEBLES',
        },
        { value: '4', label: 'EMPRESA DE SERVICIOS EVENTUALES' },
        {
            value: '5',
            label: 'EMPRESA QUE PRESTE SERVICIOS DE INVESTIGACIÓN Y SEGURIDAD.',
        },
        { value: '6', label: 'SERVICIOS GENERALES' }, // Verificar luego
    ],
    condicion_ganancias: [
        { value: '1', label: 'Exento' },
        { value: '2', label: 'Monotributo' },
        { value: '3', label: 'Residente del Exterior' },
        { value: '4', label: 'Sujeto no pasible de retención' },
        { value: '5', label: 'Sujeto con autorización de no-retención' },
        { value: '6', label: 'Responsable Inscripto' },
        {
            value: '7',
            label: 'Profesional organizado en forma de empresa (Anexo II RG 830/2000 inc. k)',
        },
        {
            value: '8',
            label: 'Sociedades de hecho (incluidas Art. 53 inc b) y d) Ley de Impuesto a las ganancias)',
        },
        {
            value: '9',
            label: 'Sujeto con autorización de auto retención RG 830/2000',
        },
    ],
    // tipo_documento: [
    //     { value: "1", label: "DNI" },
    //     { value: "3", label: "CUIL" },
    //     { value: "2", label: "CUIT" },
    //     { value: "4", label: "Libreta Civica" }
    // ],
    tipo_proveedor: [
        { value: '1', label: 'Proveedor de Bienes' },
        { value: '2', label: 'Proveedor de Servicios' },
        { value: '3', label: 'Ambos' },
    ],
    tipo_de_cuenta: [
        { value: '1', label: 'Cta. Corriente' },
        { value: '2', label: 'Caja de Ahorros' },
    ],
    booleano: [
        { value: '1', label: 'SI' },
        { value: '2', label: 'NO' },
    ],
    lic_tiempos_de_entrega: [
    {
      value: '24',
      label: '24hs'
    },
    {
      value: '48',
      label: '48hs'
    },
    {
      value: '72',
      label: '72hs'
    },
    {
      value: '12',
      label: 'Entrega inmediata'
    }
  ]
}

let persistant = window.localStorage.getItem('dictionaries')
defaultValue = persistant ? JSON.parse(persistant) : defaultValue

function createDictionaries() {
    const { subscribe, set, update } = writable(defaultValue)
    const persistValue = (val) =>
        window.localStorage.setItem('dictionaries', JSON.stringify(val))
    
    // Diccionarios virtuales (dependen de otros)
    const virtuals = {
        vprovincias: dicts => (dicts?.jurisdicciones || []).filter(({value}) => /^[0-9]+$/.test(value))
    }
    
    // Preprocesamiento de diccionarios
    const preprocess = allDicts => Object.fromEntries(
        Object.entries(allDicts)
        .concat(Object.entries(virtuals).map(([k, generator]) => [k, generator(allDicts)]))
        .map(([k, v]) => {
            return [
                k,
                v.sort((x, y) => {
                    return x.value > y.value ? 1 : -1
                }),
            ]
        })
    )
    
    return {
        subscribe,
        reset() {
            persistValue(defaultValue)
            set(defaultValue)
        },
        async load(){
            this.reset()
            try {
                fetch(`${API_URL}/dictionaries/`)
                    .then(async (r) => {
                        if (r.ok) {
                            let dicts = preprocess(await r.json())
                            dicts = {...defaultValue, ...dicts}
                            dicts.lic_tiempos_de_entrega = [
                                {
                                  value: '24',
                                  label: '24hs'
                                },
                                {
                                  value: '48',
                                  label: '48hs'
                                },
                                {
                                  value: '72',
                                  label: '72hs'
                                },
                                {
                                  value: '12',
                                  label: 'Entrega inmediata'
                                }
                              ]
                            persistValue(dicts)
                            // @ts-ignore
                            set(dicts)
                        } else {
                            return {}
                        }
                    })
                    .catch((e) => {
                        console.log(e)
                        throw new Error(
                            'Error al recuperar datos desde Athento. Verifique que la VPN esté conectada.'
                        )
                    })
            } catch (e) {
                console.log(e)
            }
        },
        update: (name, dict) => {
            return update((allDicts) => {
                let ret = Object.fromEntries([
                    ...Object.entries(allDicts),
                    [name, dict],
                ])
                persistValue(ret)
                return ret
            })
        },
    }
}

const dictionaries = createDictionaries()
dictionaries.load()
export default dictionaries
